"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _debug = _interopRequireDefault(require("debug"));

var _browserOrNode = require("browser-or-node");

var _config = require("../config");

var _v = _interopRequireDefault(require("uuid/v4"));

var _MewConnectCommon2 = _interopRequireDefault(require("../MewConnectCommon"));

var _MewConnectCrypto = _interopRequireDefault(require("../MewConnectCrypto"));

var _MewConnectInitiatorV = _interopRequireDefault(require("./MewConnectInitiatorV2"));

var _MewConnectInitiatorV2 = _interopRequireDefault(require("./MewConnectInitiatorV1"));

var _popUpCreator = _interopRequireDefault(require("../../connectWindow/popUpCreator"));

var _index = _interopRequireDefault(require("../../connectProvider/web3Provider/MEWconnect/index"));

var _popUpHandler = _interopRequireDefault(require("../../connectWindow/popUpHandler"));

var _WebRtcCommunication = _interopRequireDefault(require("../WebRtcCommunication"));

var _config2 = require("../../config");

var _package = _interopRequireDefault(require("../../../package.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var debug = (0, _debug.default)('MEWconnect:initiator-base');
var debugStages = (0, _debug.default)('MEWconnect:initiator-stages');
var debugConnectionState = (0, _debug.default)('MEWconnect:connection-state');
var qrString;

var MewConnectInitiator = /*#__PURE__*/function (_MewConnectCommon) {
  _inherits(MewConnectInitiator, _MewConnectCommon);

  var _super = _createSuper(MewConnectInitiator);

  function MewConnectInitiator() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MewConnectInitiator);

    _this = _super.call(this, options.version);
    _this.optionVersion = options.version || 2.0;
    _this.showPopup = options.showPopup || false;

    try {
      _this.supportedBrowser = _MewConnectCommon2.default.checkBrowser();
      _this.requestIds = [];
      _this.V1 = {};
      _this.V2 = {};
      _this.activePeerId = '';
      _this.allPeerIds = [];
      _this.peersCreated = [];
      _this.v1Url = options.v1Url || _config.V1endpoint;
      _this.v2Url = options.v2Url || _config.V2endpoint;
      _this.turnTest = options.turnTest;

      _this.destroyOnUnload(typeof window !== 'undefined');

      _this.p = null;
      _this.socketV2Connected = false;
      _this.socketV1Connected = false;
      _this.showingQR = false;
      _this.connected = false;
      _this.tryingTurn = false;
      _this.turnDisabled = false;
      _this.signalUrl = null;
      _this.iceState = '';
      _this.turnServers = [];
      _this.refreshDelay = 20000;
      _this.socketsCreated = false;
      _this.refreshCount = 0;
      _this.abandonedTimeout = 300000;
      _this.showingRefresh = false;
      _this.mewCrypto = options.cryptoImpl || _MewConnectCrypto.default.create();
      _this.webRtcCommunication = new _WebRtcCommunication.default(_this.mewCrypto);
      _this.popupCreator = options.popupCreator ? options.popupCreator : options.newPopupCreator ? new _popUpCreator.default() : undefined;
      debugConnectionState('Initial Connection State:', MewConnectInitiator.getConnectionState());
      _this.version = _this.jsonDetails.version;
      _this.lifeCycle = _this.jsonDetails.lifeCycle;
      _this.iceStates = _this.jsonDetails.iceConnectionState;
      _this.stunServers = options.stunServers || _this.jsonDetails.stunSrvers; // Socket is abandoned.  disconnect.

      _this.timer = null;
      setTimeout(function () {
        if (_this.socket) {
          _this.socketDisconnect();
        }
      }, _this.abandonedTimeout);
      console.log("Using MEWconnect v".concat(_package.default.version));
    } catch (e) {
      debug('constructor error:', e);
    }

    return _this;
  }

  _createClass(MewConnectInitiator, [{
    key: "createWalletOnly",
    value: function () {
      var _createWalletOnly = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(network) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.popUpHandler = new _popUpHandler.default();
                return _context.abrupt("return", (0, _index.default)({
                  network: network
                }, this.popupCreator, this.popUpHandler));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createWalletOnly(_x) {
        return _createWalletOnly.apply(this, arguments);
      }

      return createWalletOnly;
    }()
  }, {
    key: "isAlive",
    value: function isAlive() {
      if (this.p !== null) {
        return this.p.connected && !this.p.destroyed;
      }

      return false;
    }
  }, {
    key: "focusPopupWindow",
    value: function focusPopupWindow() {
      if (!this.popupCreator) return;

      if (this.popupCreator.popupWindowOpen) {
        this.popupCreator.popupWindow.focus();
      }
    } // Check if a WebRTC connection exists before a window/tab is closed or refreshed
    // Destroy the connection if one exists

  }, {
    key: "destroyOnUnload",
    value: function destroyOnUnload() {
      var _this2 = this;

      if (_browserOrNode.isBrowser) {
        try {
          // eslint-disable-next-line no-undef
          if (!window) return; // eslint-disable-next-line no-undef

          window.onunload = window.onbeforeunload = function () {
            var iceStates = [_this2.iceStates.new, _this2.iceStates.connecting, _this2.iceStates.connected];

            if (_this2.Peer) {
              if (!_this2.Peer.destroyed || iceStates.includes(_this2.iceState)) {
                _this2.rtcDestroy();
              }
            }

            if (_this2.popupCreator) {
              _this2.popupCreator.removeWindowClosedListener();

              _this2.popupCreator.closePopupWindow();
            }
          };
        } catch (e) {
          debug(e);
        }
      }
    }
  }, {
    key: "getSocketConnectionState",
    value: // Returns a boolean indicating whether the socket connection exists and is active
    function getSocketConnectionState() {
      return this.socketV1Connected || this.socketV2Connected;
    } // Returns a boolean indicating whether the WebRTC connection exists and is active

  }, {
    key: "getConnectonState",
    value: function getConnectonState() {
      return this.connected;
    } // can be used to listen to specific events, especially those that pass data

  }, {
    key: "uiCommunicator",
    value: function uiCommunicator(event, data) {
      debug('MewConnectInitiator event emitted', event);
      this.emit(event, data);
      this.emitStatus(event);
    } // special status emitter to allow simple listening of various statuses in one listener

  }, {
    key: "emitStatus",
    value: function emitStatus(event) {
      this.emit('status', event);
    } // Emit/Provide the details used in creating the QR Code

  }, {
    key: "displayCode",
    value: function displayCode(privateKey) {
      var _this3 = this;

      try {
        if (privateKey instanceof Buffer) {
          privateKey = privateKey.toString('hex');
        }

        var dapp = 'example';

        if (typeof window !== 'undefined') {
          dapp = window.location.hostname;
        }

        debug('handshake', privateKey);
        this.socketKey = privateKey;
        var separator = this.jsonDetails.connectionCodeSeparator;
        var qrCodeString = this.version + separator + privateKey + separator + this.connId + ':name=' + dapp.replace(/^www\./, '');

        if (dapp.includes('myetherwallet.com')) {
          qrCodeString = this.version + separator + privateKey + separator + this.connId;
        } else if (dapp.includes('mewbuilds.com')) {
          qrCodeString = this.version + separator + privateKey + separator + this.connId;
        } else if (dapp.includes('localhost')) {
          qrCodeString = this.version + separator + privateKey + separator + this.connId;
        }

        qrString = qrCodeString;

        var unloadOrClosed = function unloadOrClosed() {
          if (!_this3.connected) {
            // eslint-disable-next-line no-console
            debug('popup window closed');

            _this3.uiCommunicator('popup_window_closed');

            MewConnectInitiator.setConnectionState();

            _this3.socketDisconnect();

            _this3.emit(_this3.lifeCycle.AuthRejected);
          }
        };

        debug(qrCodeString);
      } catch (e) {
        debug('displayCode error:', e);
      }
    }
  }, {
    key: "ShowQr",
    value: function ShowQr(qrCodeString) {
      var _this4 = this;

      var unloadOrClosed = function unloadOrClosed() {
        if (!_this4.connected) {
          // eslint-disable-next-line no-console
          debug('popup window closed');

          _this4.uiCommunicator('popup_window_closed');

          MewConnectInitiator.setConnectionState();

          _this4.socketDisconnect();

          _this4.emit(_this4.lifeCycle.AuthRejected);
        }
      };

      debug(qrCodeString);

      if (this.showPopup) {
        if (this.popupCreator.popupWindowOpen) {
          if (this.popupCreator) this.popupCreator.updateQrCode(qrCodeString);
        } else {
          if (this.popupCreator) this.popupCreator.refreshQrcode = this.initiatorStart.bind(this);
          this.popupCreator.openPopupWindow(qrCodeString);
          if (this.popupCreator) this.popupCreator.container.addEventListener('mewModalClosed', unloadOrClosed, {
            once: true
          });
        }
      } else {
        this.uiCommunicator(this.lifeCycle.codeDisplay, qrCodeString); // this.uiCommunicator(this.lifeCycle.checkNumber, privateKey);

        this.uiCommunicator(this.lifeCycle.ConnectionId, this.connId);
      }
    }
    /*
    ===================================================================================
    Keys
    ===================================================================================
    */

    /* Set the public and private keys, connId, and signed that will be used
     * for the duration of the pairing process. The receiver will need to have access
     * to this information as well, however, the initiator creates the credentials to be
     * shared with the receiver.
     */

  }, {
    key: "generateKeys",
    value: function generateKeys(testPrivate) {
      if (!this.mewCrypto) this.mewCrypto = _MewConnectCrypto.default.create();
      var keys = {};

      if (testPrivate) {
        keys = this.mewCrypto.setPrivate(testPrivate);
      } else {
        keys = this.mewCrypto.generateKeys();
      }

      this.publicKey = keys.publicKey;
      this.privateKey = keys.privateKey;
      this.connId = this.mewCrypto.generateConnId(this.publicKey);
      this.signed = this.mewCrypto.signMessageSync(this.privateKey, this.privateKey);
      debug('this.signed', this.signed);
    }
  }, {
    key: "refreshCode",
    value: function () {
      var _refreshCode = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this5 = this;

        var v2Events, webRtcCommEvents;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // this.showingRefresh = false;
                v2Events = ['sendingOffer', 'retryingViaTurn', 'socketDisconnected', 'socketPaired'];
                webRtcCommEvents = ['disconnected', 'data', 'UsingFallback', 'showRefresh', 'decryptError', 'RtcConnectedEvent', 'signal']; // "sendingOffer", "retryingViaTurn", "socketDisconnected", "socketPaired"
                // "disconnected", "data", "UsingFallback", "showRefresh", "decryptError", "RtcConnectedEvent", "signal"

                webRtcCommEvents.forEach(function (event) {
                  return _this5.webRtcCommunication.removeAllListeners(event);
                });
                v2Events.forEach(function (event) {
                  return _this5.V2.removeAllListeners(event);
                });
                this.V2.socketDisconnect();
                if (this.popupCreator) this.popupCreator.popupWindowOpen = true;
                this.webRtcCommunication = new _WebRtcCommunication.default(this.mewCrypto);
                this.initiatorStart();

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function refreshCode() {
        return _refreshCode.apply(this, arguments);
      }

      return refreshCode;
    }() // TODO change this to use supplied urls at time point

  }, {
    key: "initiatorStart",
    value: function () {
      var _initiatorStart = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee3(url, testPrivate) {
        var _this6 = this;

        var options, regenerateQRcodeOnClick, showRefresh, connectionErrorTimeOut;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.socketV1Connected) {
                  this.V1.socketDisconnect();
                }

                if (this.socketV2Connected) {
                  this.V2.socketDisconnect();
                }

                this.generateKeys(testPrivate);
                this.displayCode(this.privateKey);
                this.webRtcCommunication.once(this.lifeCycle.disconnected, this.uiCommunicator.bind(this, this.lifeCycle.RtcClosedEvent));
                options = {
                  stunServers: this.stunServers,
                  turnTest: this.turnTest,
                  version: this.optionVersion,
                  uiCommunicator: this.uiCommunicator.bind(this),
                  webRtcCommunication: this.webRtcCommunication,
                  crypto: this.mewCrypto
                };
                this.webRtcCommunication.on('data', this.dataReceived.bind(this));
                _context3.prev = 7;
                this.V2 = new _MewConnectInitiatorV.default(_objectSpread({
                  url: _config.V2endpoint
                }, options));
                _context3.next = 11;
                return this.V2.initiatorStart(_config.V2endpoint, this.mewCrypto, {
                  signed: this.signed,
                  connId: this.connId
                });

              case 11:
                this.V2.on('sendingOffer', function () {
                  if (_this6.popupCreator) _this6.popupCreator.showConnecting();
                });
                this.V2.on('retryingViaTurn', function () {
                  _this6.showingRefresh = false; // reset refresh
                });

                regenerateQRcodeOnClick = function regenerateQRcodeOnClick() {
                  debug('REGENERATE');

                  _this6.refreshCode();
                };

                showRefresh = function showRefresh() {
                  if (!_this6.connected) {
                    if (!_this6.showingRefresh) {
                      _this6.showingRefresh = true; // only process one refresh event

                      if (_this6.popupCreator) _this6.popupCreator.showRetry(regenerateQRcodeOnClick);
                    }
                  }
                };

                this.V2.on('socketDisconnected', showRefresh.bind(this));
                this.V2.on('showRefresh', showRefresh.bind(this));
                this.webRtcCommunication.on('showRefresh', showRefresh.bind(this));
                this.webRtcCommunication.on(this.lifeCycle.decryptError, function () {
                  if (_this6.webRtcCommunication.initialAddressRequest !== 'complete') {
                    MewConnectInitiator.setConnectionState(_config2.DISCONNECTED);

                    _this6.webRtcCommunication.rtcDestroy();
                  }
                });
                _context3.next = 25;
                break;

              case 21:
                _context3.prev = 21;
                _context3.t0 = _context3["catch"](7);
                // eslint-disable-next-line
                console.error(_context3.t0);
                this.V2 = null;

              case 25:
                _context3.prev = 25;
                this.V1 = new _MewConnectInitiatorV2.default(_objectSpread({
                  url: _config.V1endpoint
                }, options));
                _context3.next = 29;
                return this.V1.initiatorStart(_config.V1endpoint, this.mewCrypto, {
                  signed: this.signed,
                  connId: this.connId
                });

              case 29:
                _context3.next = 35;
                break;

              case 31:
                _context3.prev = 31;
                _context3.t1 = _context3["catch"](25);
                // eslint-disable-next-line
                console.error(_context3.t1);
                this.V1 = {};

              case 35:
                if (!this.V2) {} // this.ShowQr(qrString);


                this.webRtcCommunication.setActiveInitiatorId(this.V2.initiatorId);
                connectionErrorTimeOut = setTimeout(function () {
                  window.alert('Failed to start MEWconnect. Please try again.');
                }, 60000);

                if (this.V1.on) {
                  this.V1.on('socketPaired', function () {
                    if (_this6.V2.socketDisconnect) _this6.V2.socketDisconnect();
                    _this6.socketV1Connected = true;
                  });
                  this.V1.once('SOCKET_CONNECTED', function () {
                    if (!_this6.showingQR) {
                      clearTimeout(connectionErrorTimeOut);
                      _this6.showingQR = true;

                      _this6.ShowQr(qrString);
                    }
                  });
                }

                if (this.V2.on) {
                  this.V2.on('socketPaired', function () {
                    if (_this6.V1.socketDisconnect) _this6.V1.socketDisconnect();
                    _this6.socketV2Connected = true;
                  });
                  this.V2.once('SOCKET_CONNECTED', function () {
                    if (!_this6.showingQR) {
                      clearTimeout(connectionErrorTimeOut);
                      _this6.showingQR = true;

                      _this6.ShowQr(qrString);
                    }
                  });
                }

                this.webRtcCommunication.once(this.jsonDetails.lifeCycle.RtcConnectedEvent, function (peerid) {
                  _this6.webRtcCommunication.removeAllListeners(_this6.jsonDetails.lifeCycle.RtcConnectedEvent);

                  debug('RTC CONNECTED ENVIRONMENT SETUP');

                  _this6.emit(_this6.lifeCycle.RtcConnectedEvent);

                  _this6.webRtcCommunication.on('appData', _this6.dataReceived.bind(_this6));

                  _this6.connected = true;
                  if (_this6.popupCreator) _this6.popupCreator.removeWindowClosedListener();
                  if (_this6.popupCreator) _this6.popupCreator.closePopupWindow();
                  MewConnectInitiator.setConnectionState(_config2.CONNECTED);
                });

              case 41:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[7, 21], [25, 31]]);
      }));

      function initiatorStart(_x2, _x3) {
        return _initiatorStart.apply(this, arguments);
      }

      return initiatorStart;
    }()
  }, {
    key: "socketDisconnect",
    value: function socketDisconnect() {
      this.V2.socketDisconnect();
      this.V1.socketDisconnect();
    }
  }, {
    key: "disconnectRTC",
    value: function disconnectRTC() {
      if (this.connected) {
        debugStages('DISCONNECT RTC');
        this.uiCommunicator(this.lifeCycle.RtcDisconnectEvent);
        this.webRtcCommunication.disconnectRTC();
        this.connected = false;
        this.instance = null;
      }
    }
  }, {
    key: "rtcSend",
    value: function () {
      var _rtcSend = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee4(arg) {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.webRtcCommunication.rtcSend(arg);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function rtcSend(_x4) {
        return _rtcSend.apply(this, arguments);
      }

      return rtcSend;
    }()
  }, {
    key: "sendRtcMessage",
    value: function sendRtcMessage(type, data) {
      var id = (0, _v.default)();
      this.requestIds.push(id);
      debug('MESSAGE IDS KNOWN', this.requestIds);
      this.webRtcCommunication.sendRtcMessage(type, data, id);
    }
  }, {
    key: "dataReceived",
    value: function dataReceived(data) {
      debug('dataReceived', data); // this.webRtcCommunication.once('appData', this.dataReceived.bind(this));

      if (data.id) {
        debug('MESSAGE ID RECEIVED', data.id);

        if (this.requestIds.includes(data.id)) {
          this.uiCommunicator(data.type, data.data);
          var idx = this.requestIds.findIndex(function (item) {
            return item === id;
          });
          this.requestIds.splice(idx, 1);
          debug('MESSAGE IDS KNOWN', this.requestIds);
        } else {
          debug('**NO MESSAGE ID RECEIVED : field present**');
          this.uiCommunicator(data.type, data.data);
        }
      } else {
        debug('**NO MESSAGE ID RECEIVED : field absent**');
        this.uiCommunicator(data.type, data.data);
      }
    }
  }, {
    key: "testV1Turn",
    value: function testV1Turn() {
      this.V1.disconnectRTC();
    }
  }, {
    key: "testV2Turn",
    value: function testV2Turn() {
      this.V2.disconnectRTC();
      this.V2.emit(this.lifeCycle);
    }
  }], [{
    key: "setConnectionState",
    value: function setConnectionState(connectionState) {
      if (!connectionState) MewConnectInitiator.connectionState = _config2.DISCONNECTED;else MewConnectInitiator.connectionState = connectionState;
    }
  }, {
    key: "getConnectionState",
    value: function getConnectionState() {
      if (!MewConnectInitiator.connectionState) return _config2.DISCONNECTED;
      return MewConnectInitiator.connectionState;
    }
  }, {
    key: "checkBrowser",
    value: function checkBrowser() {
      return _MewConnectCommon2.default.checkBrowser();
    }
  }, {
    key: "checkWebRTCAvailable",
    value: function checkWebRTCAvailable() {
      return _MewConnectCommon2.default.checkWebRTCAvailable();
    }
  }]);

  return MewConnectInitiator;
}(_MewConnectCommon2.default);

exports.default = MewConnectInitiator;